module.exports = __webpack_public_path__ + "img/about_3.8b2fc0ad.png";